<template>
    <div class="preparescjpage margin-top" v-loading="loadingDownload"  >
        <a href="" class="downloadFile"></a>
        <div class="padding-y">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item  >试卷中心</el-breadcrumb-item>
                <el-breadcrumb-item>试卷收藏页</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="containWrap d-flex justify-content">

            <div class="left-catalog public_scroll_bar" v-loading="loadingCollection">
                <div class="tree-con d-flex alignCenter"
                     :class="selectDirectoryId===item.categoryId?'directoryActive':''" @click="selectDirectoryTap(item.categoryId)"
                     v-for="item in getLeftCollectionData" :key="item.categoryId">
                                <span class="text-ellipsis alignCenter d-flex">
                                    <span class="el-icon-document"></span>
                                    <span>{{item.categoryName}}</span>
                                </span>
                    <div class="tree-btns display-b-i"  v-show="!item.isSys">
                        <el-button type="text" @click="changeNameDialog(item.categoryId,item.categoryName)">重命名</el-button>
                        <el-button type="text" @click="delCollection(item.categoryId)" class="text-danger">删除</el-button>
                    </div>
                </div>
            </div>
            <div class="right-catalog" v-loading="loadingRightContent" >
                <div>
                    <div class="selection-panel  ">
                        <p>
                            <label>年级：</label>
                            <span class="yearList">
                                <el-button v-for="(item,index) in gradeList" :class="gradeId===item.id?'select':''" :key="index"
                                           @click="selectGrade(item.id)">
                                    {{item.name}}
                                </el-button>
                            </span>
                        </p>
                        <p class="provinceBox">
                            <span class="float-left">学科：</span>
                            <span class="provinceList" >
                                <el-button v-for="(item,index) in subjectList" :class="subjectId===item.subjectId?'select':''" :key="index"
                                           @click="selectSubject(item.subjectId)">
                                    {{item.subjectName}}
                                </el-button>
                            </span>
                        </p>
                    </div>
                </div>
                <div v-show="getCollectionContentList.length>0">
                    <div class="cardContent padding-b public_scroll_bar">
                        <div class="padding alignCenter d-flex justify-content" v-for="item in getCollectionContentList" :key="item.id">
                            <!--                            <div></div>-->
                            <div class="title">
                                <div class="titleName">
                                    {{item.name}}
                                </div>
                                <div class="titleDescribe">
                                    <span>更新日期：{{item.updatedAt}}</span>
                                    <span>浏览次数：{{item.viewTimes}}</span>
                                    <span>下载次数：{{item.downTimes}}</span>
                                </div>
                            </div>
                            <div>
                                <el-button type="text" @click="cancelCollection(item.paperId)">取消收藏</el-button>
                                <el-button type="text" @click="dowloadKjZy(item.paperId,item.name)">下载</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="text-right margin-top">
                        <el-pagination
                                layout="total, prev, pager, next, jumper"
                                :page-size="5"
                                :total="totalItem"
                                :current-page.sync="currentPage"
                                @current-change="handlerPage">
                        </el-pagination>
                    </div>
                </div>
                <div v-show="getCollectionContentList<1">
                    <empty ></empty>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {message} from 'element-ui'
    import {
        testPaperDownload,
        testPaperFav,
        testPaperFavCategory,
        testPaperFavList,
        testPaperSubjects
    } from "../../../config";
    import {commonDowloadFile} from "../../../assets/static/global/global";
    export default {
        name: "testPaperCollection",
        data(){
            return{
                gradeList:[
                    {
                        name:'高一',
                        id:1
                    },
                    {
                        name:'高二',
                        id:2
                    },
                    {
                        name:'高三',
                        id:3
                    },
                ],

                gradeId:1,
                //获取左侧收藏夹列表
                getLeftCollectionData:[],
                //设置收藏夹的加载项
                loadingCollection:true,
                //设置右侧内容的加载项
                loadingRightContent:true,
                //获取当前所选择的目录
                selectDirectoryId:'',
                currentPage:1,
                totalItem:1,
                //获取收藏夹中的内容
                getCollectionContentList:[],
                subjectList:[],
                subjectId:null,
                loadingDownload:false
            }
        },
        mounted(){
            this.getLeftCollection();
            this.searchSubjectList();
        },
        methods:{

            selectSubject(val){
                this.currentPage=1;
                this.subjectId=val;
                this.getRightContent();
            },
            selectGrade(val){
                this.currentPage=1;
                this.gradeId=val;
                this.getRightContent();

            },
            //默认查出学科列表
            async searchSubjectList(){
                let result=await testPaperSubjects();
                if(result.status){
                    this.subjectList=result.data;
                }else{
                }
            },
            //下载试卷
            async dowloadKjZy(val,valName){
                this.loadingDownload=true;
                let result=await testPaperDownload(val.id);
                if(result.status){
                    let zhi=window.atob(result.data);
                    var link = document.createElement("a");
                    var body = document.querySelector("body");
                    link.href =zhi;
                    link.style.display="none";
                    body.appendChild(link);
                    link.click();
                    body.removeChild(link);
                    this.loadingDownload=false;

                }else{
                    this.loadingDownload=false;
                }
            },
            //取消收藏
            async cancelCollection(val){
                let result=await testPaperFav(val,2);
                if(result.status){
                    message({
                        message:'取消收藏成功！',
                        type:'success'
                    })
                    this.searchTestPaper();
                }else{

                }
            },

            selectDirectoryTap(val){
                this.currentPage=1;
                this.selectDirectoryId=val;
                this.getRightContent();
            },
            handlerPage(){
                this.getRightContent();
            },
            //获取左侧收藏夹
            async getLeftCollection(){
                this.loadingCollection=true;
                let result=await testPaperFavCategory();
                if(result.status){
                    this.loadingCollection=false;
                    this.getLeftCollectionData=result.data;
                    this.selectDirectoryId=result.data[0].categoryId;
                    this.getRightContent();
                }else{
                    this.loadingCollection=false;
                }
            },
            //获取右侧根据收藏夹查出相关收藏夹下的课件内容
            async getRightContent(){
                this.loadingRightContent=true;
                let result=await testPaperFavList(this.selectDirectoryId,this.gradeId,this.subjectId,this.currentPage,5);
                if(result.status){
                    this.loadingRightContent=false;
                    this.getCollectionContentList=result.data.data;
                    this.totalItem=result.data.totalRecords;
                }else{
                    this.loadingRightContent=false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
 @import "../../../assets/static/commonStyle/collectionPage";
    .cardContent{
        margin-top: 20px;
    }
 .selection-panel {
     background: #ffffff;
     -webkit-box-shadow: 0 0 6px 0 rgb(73 83 98 / 12%);
     box-shadow: 0 0 6px 0 rgb(73 83 98 / 12%);
     padding-bottom: 10px;
     padding-top: 10px;
     .yearList{
         .el-button{
             margin-left: 10px;
         }
     }
     .provinceBox{
         .provinceList{
             width:770px;
             height:20px;
             display: inline-block;
             overflow: hidden;
             .el-button{
                 margin-left: 10px;

             }
         }
         .provinceList.show{
             height: auto!important;

         }
         .cursorSz{
             float: right;
             color: #209cff;
         }
     }
     p {
         margin: 10px 10px;

         span {
             .el-button {
                 display: inline;
                 border: none;
                 //background-color: transparent;
                 cursor: pointer;
                 padding: 5px 10px;
                 outline: none;
                 line-height: 1;
             }
         }
     }

 }
</style>